import SlideAPI from '@/api/slide'
import AudienceAPI from '@/api/audience'
import ReactionAPI from '@/api/reaction'
import SlideOptionApi from '@/api/slide-option'
import ChatApi from '@/api/chat'
import QuestionApi from '@/api/question'
import UserApi from '@/api/user'
import PrivateFeedbackApi from '@/api/private-feedback'
import Answers from '@/api/answers'
import PresentationAudienceLatency from '@/api/presentation-audience-latency'
import AttendedPresentationsApi from '@/api/attended-presentations'
import { initResources as kvSyncApiInitResources } from '@/api/kvSync'
import participantInfo from '@/api/participant-info'
import UploadLogApi from '@/api/upload-log'
import presentationAttribute from './presentation-attribute'
import counting from './counting'

const initResources = () => {
  SlideAPI.initResource()
  AudienceAPI.initResource()
  ReactionAPI.initResource()
  SlideOptionApi.initResource()
  ChatApi.initResource()
  QuestionApi.initResource()
  UserApi.initResource()
  PrivateFeedbackApi.initResource()
  Answers.initResource()
  PresentationAudienceLatency.initResource()
  AttendedPresentationsApi.initResource()
  kvSyncApiInitResources()
  presentationAttribute.initResource()
  participantInfo.initResource()
  counting.initResource()
  UploadLogApi.initResource()
}

export default {
  initResources,
}
